<template>
  <div>
    <div class="container">
      <div class="row mt-2">
        <div class="col-md-9">
        </div>
        <div class="col-md-3">
            <boton-atras :nombre_ruta="'Home'"/>
        </div>
        <div v-for="(link, index) in links" :key="index" class="col-md-6">
            <a v-if="link.type === 'external'" :href="link.url" target="_blank"><cardsMenu  :card="link"/></a>
            <router-link v-else :to="{name: link.route}"><cardsMenu  :card="link"/></router-link>
          </div>
      </div>
      <span v-html="DateFormatText('2018-02-20')"></span>
    </div>
  </div>
</template>
<script>
import cardsMenu from '../../components/cardsMenu.vue'
import botonAtras from './../button-atras'
import DateFormat from "@/mixins/dateFormatMixin.js";
export default {
  components:{cardsMenu, botonAtras},
  mixins: [DateFormat],
  data()
  {
    return{
      links: [
        { id: 1, esIcono: false, recurso: "img/armonizacion/armonizacion.jpg", titulo: 'CACE - Consejo de Armonización Contable del Estado de Chiapas', type: 'external', url: 'http://www.cace.chiapas.gob.mx/' },
        { id: 2, esIcono: false, recurso: "img/armonizacion/avances.jpg", titulo: 'Avances Chiapas', type: 'internal', route: 'avanceChiapas' },
        { id: 3, esIcono: false, recurso: "img/armonizacion/aprobados.jpg", titulo: 'Documentos Aprobados por el CONAC', type: 'internal', route: 'documentosAprobadosConac' },
        { id: 4, esIcono: false, recurso: "img/armonizacion/publicados.jpg", titulo: 'Documentos Publicados Chiapas', type: 'internal', route: 'documentosPublicadosChiapas' },
        { id: 5, esIcono: false, recurso: "img/armonizacion/SEVAC.jpg", titulo: 'Resultados de las Evaluaciones', type: 'internal', route: 'resultadosEvaluaciones' },
        { id: 6, esIcono: false, recurso: "img/armonizacion/formatos.jpg", titulo: 'Informes Secretaría de Hacienda (Formatos CONAC)', type: 'internal', route: 'informesSHaciendaConac' }
      ]
    }
  },
    mounted(){
      window.scrollTo(0, 0);
  }
}
</script>

